import Start from '../components/pages/Start/Start';
export default Start;
